import React, { useState } from 'react';
import Modal from '../../../_ui/Modal/Modal';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Input from '../../../_ui/Input/Input';
import withTranslation from '../../../components/_hoc/withTranslation';
import Form from '../../../_ui/Form/Form';
import Row from '../../../_ui/Row';
import * as Yup from 'yup';
import Button from '../../../_ui/Button/Button';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { rejectRevisionSupplierApplications, statementModule } from '../StatementDucks';
import i18next from 'i18next';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

const ValidationSchema = Yup.object().shape({
  negativeResolutionReasonTextRu: Yup.string().required(() =>
    i18next.t('field_required')
  ),
  negativeResolutionReasonTextKk: Yup.string().required(() =>
    i18next.t('field_required')
  )
});

function RejectRevisionSupplierApplications({ onClose, id, rejectRevisionSupplierApplications, t, loading }) {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFileName(selectedFile.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        // Keeping only the base64 string part
        const base64 = reader.result.split(',')[1];
        setFile(base64);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  return (
    <Modal open title={t('statement_rejectTitle')} onClose={onClose} maxWidth="sm">
      <Form
        onSubmit={values =>
          rejectRevisionSupplierApplications(id, { ...values, protocol: file }, onClose)
        }
        validate={ValidationSchema}
      >
        <DialogContent dividers>
          <Row label={t('statement_rejectReasonKk')} className="flex items-start">
            <Input
              name="negativeResolutionReasonTextKk"
              placeholder={t('statement_rejectReasonKk')}
              multiline
            />
          </Row>
          <Row label={t('statement_rejectReasonRu')} className="flex items-start">
            <Input
              name="negativeResolutionReasonTextRu"
              placeholder={t('statement_rejectReasonRu')}
              multiline
            />
          </Row>
          <Row label={t('statement_attachFile')} className="flex items-start">
            <input
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              className="display-none"
              id="contained-button-file"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="contained-button-file">
              <Button
                component="span"
                color="primary"
                text={t('statement_attachFile')}
                icon={<AttachFileIcon className="mr1" />}
              />
            </label>
            {file && (
              <div className="flex items-center ml2">
                <span className="mr1">{fileName}</span>
                <IconButton
                  onClick={() => {
                    setFile(null);
                    setFileName('');
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            )}
          </Row>
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="secondary"
            text={t('statement_reject')}
            loading={loading}
          />
        </DialogActions>
      </Form>
    </Modal>
  );
}

export default compose(
  withTranslation,
  connect(
    state => ({
      loading: state[statementModule].loadingRejectRevisionSupplier
    }),
    { rejectRevisionSupplierApplications }
  )
)(RejectRevisionSupplierApplications);

